__turbopack_context__.v({
  "option": "Rrudua_option",
  "switch": "Rrudua_switch",
  "thumb": "Rrudua_thumb",
  "variantGrouping": "Rrudua_variantGrouping",
});
